import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, Send, CheckCircle2 } from 'lucide-react';
export function Contact() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    setTimeout(() => setStatus('success'), 1200);
  };
  return <div className="bg-gray-50 min-h-screen" data-id="element-1432">
      <div className="bg-white border-b border-gray-200" data-id="element-1433">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1434">
          <h1 className="text-3xl md:text-4xl font-extrabold text-yarbo-dark mb-2" data-id="element-1435">
            Contact Merem Robotics
          </h1>
          <p className="text-gray-600 max-w-2xl" data-id="element-1436">
            Order support, product selection help, and general questions about
            Yarbo systems.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-1437">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1438">
          {/* Info */}
          <div className="lg:col-span-1 space-y-4" data-id="element-1439">
            <div className="bg-white p-6 rounded-2xl border border-gray-200" data-id="element-1440">
              <h3 className="font-bold text-yarbo-dark mb-4" data-id="element-1441">Reach Us</h3>
              <div className="space-y-4 text-sm" data-id="element-1442">
                <div className="flex items-start gap-3" data-id="element-1443">
                  <Mail className="w-5 h-5 text-yarbo-yellow mt-0.5" data-id="element-1444" />
                  <div data-id="element-1445">
                    <div className="font-bold text-gray-900" data-id="element-1446">Email</div>
                    <a href="mailto:info@meremrobotics.com" className="text-gray-600 hover:text-yarbo-dark" data-id="element-1447">
                      info@meremrobotics.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-1448">
                  <MapPin className="w-5 h-5 text-yarbo-yellow mt-0.5" data-id="element-1449" />
                  <div data-id="element-1450">
                    <div className="font-bold text-gray-900" data-id="element-1451">Location</div>
                    <div className="text-gray-600" data-id="element-1452">Michigan, USA</div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-1453">
                      Shipping nationwide
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-yarbo-charcoal text-white p-6 rounded-2xl" data-id="element-1454">
              <h3 className="font-bold mb-3" data-id="element-1455">Common Topics</h3>
              <ul className="space-y-2 text-sm text-gray-300" data-id="element-1456">
                <li data-id="element-1457">• Help choosing the right Yarbo system</li>
                <li data-id="element-1458">• Order status and tracking</li>
                <li data-id="element-1459">• Shipping & returns questions</li>
                <li data-id="element-1460">• Module compatibility questions</li>
              </ul>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-2" data-id="element-1461">
            <div className="bg-white p-8 rounded-2xl border border-gray-200" data-id="element-1462">
              {status === 'success' ? <motion.div initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} className="text-center py-10" data-id="element-1463">
                  <CheckCircle2 className="w-14 h-14 text-green-500 mx-auto mb-4" data-id="element-1464" />
                  <h3 className="text-2xl font-bold text-yarbo-dark mb-2" data-id="element-1465">
                    Message sent
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-1466">
                    Thanks for reaching out. We'll reply by email.
                  </p>
                  <button onClick={() => setStatus('idle')} className="text-sm font-bold text-yarbo-dark hover:underline" data-id="element-1467">
                    Send another message
                  </button>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1468">
                  <h3 className="text-2xl font-bold text-yarbo-dark mb-4" data-id="element-1469">
                    Send us a message
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-1470">
                    <div data-id="element-1471">
                      <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-1472">
                        Name *
                      </label>
                      <input type="text" required className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none" data-id="element-1473" />
                    </div>
                    <div data-id="element-1474">
                      <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-1475">
                        Email *
                      </label>
                      <input type="email" required className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none" data-id="element-1476" />
                    </div>
                  </div>

                  <div data-id="element-1477">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-1478">
                      Topic
                    </label>
                    <select className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none bg-white" data-id="element-1479">
                      <option data-id="element-1480">Product selection help</option>
                      <option data-id="element-1481">Order status</option>
                      <option data-id="element-1482">Shipping & returns</option>
                      <option data-id="element-1483">Module compatibility</option>
                      <option data-id="element-1484">General question</option>
                    </select>
                  </div>

                  <div data-id="element-1485">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-1486">
                      Message *
                    </label>
                    <textarea required rows={5} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none resize-none" data-id="element-1487" />
                  </div>

                  <button type="submit" disabled={status === 'submitting'} className="w-full bg-yarbo-dark text-white font-bold py-4 rounded-lg hover:bg-black transition-colors flex justify-center items-center gap-2" data-id="element-1488">
                    {status === 'submitting' ? 'Sending...' : <>
                        Send Message <Send className="w-4 h-4" data-id="element-1489" />
                      </>}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}